import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-time-display',
  templateUrl: './time-display.component.html',
  styleUrls: ['./time-display.component.css'],
  imports: [TranslocoDirective],
})
export class TimeDisplayComponent implements OnInit, OnChanges {
  @Input() chartTitle = '';
  @Input() timeInSeconds = 0;
  timeInMinutesAndSeconds = '';
  constructor() {}

  ngOnInit(): void {
    this.timeInMinutesAndSeconds = this.formatTime(this.timeInSeconds);
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.timeInSeconds) {
      this.timeInMinutesAndSeconds = this.formatTime(this.timeInSeconds);
    }
  }
  /**
   * Formats seconds into a human-readable time string.
   *
   * @param {number} seconds - The number of seconds to format.
   * @returns {string} The formatted time string in the "mm:ss" format.
   * Check if the remaining seconds are less than 10 and zero-pad them if needed.
   */
  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    if (remainingSeconds < 10) {
      return `${minutes}:0${remainingSeconds}`;
    }
    return `${minutes}:${remainingSeconds}`;
  }
}
